import { Toast } from '@shared/components/toast';

export const CLERK_CREATE_APP_TOAST_CONFIG: Record<string, Toast> = {
  error: {
    type: 'error',
    message:
      'An error occurred while creating the application. Please try again.',
  },
};
